<script setup>
import { useStore } from 'vuex'
import { computed } from 'vue'
import { usePromotions } from '@/composables/usePromotions'
import { applyTournamentStructure } from '@/store/solfigr/solfigr_helpers'
import IcmStructuresTables from '@/components/DataTables/v2/tables/IcmStructuresTable/IcmStructuresTables.vue'
import DialogTemplate from '@/components/Dialogs/DialogTemplate.vue'

const store = useStore()
const { userHasRbwizardPromo } = usePromotions()

const props = defineProps({ dialog: Object })

const namespace = computed(() => props.dialog.namespace || null)

const close = () => {
  store.dispatch('router_rm_dialog', 'solfigr-icm-structures-dialog')
}

const handleClick = ({ item }) => {
  applyTournamentStructure({ item, namespace: namespace.value, store })
  close()
}
</script>

<template>
  <DialogTemplate
    data-tst="solfigr_rakedialog"
    style="--dialog-content-overflow: none"
  >
    <IcmStructuresTables
      style="mh-0"
      @click:item="handleClick"
    />

    <template #dialog_actions>
      <a
        v-if="userHasRbwizardPromo"
        class="d-flex text-underline text-medium weight_500 h-100 align-center"
        href="https://rbwizard.com"
        target="_blank"
        >{{ $t('messages.shortcut_dialog_rbwizard_promo') }}</a
      >
      <v-btn
        class="ml-auto"
        data-tst="btn_apply"
        variant="text"
        @click="close"
        >{{ $t('btn.close') }}</v-btn
      >
      <portal-target name="dialog_actions" />
    </template>
  </DialogTemplate>
</template>
